export const ProductPresenter = (product) => {
  if (!product) return {};
  return {
    cluster: product.cl,
    name: product.name,
    number: product.n,
    material: product.mat,
    model: product.m,
    collection: product.col,
  };
};
